import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient, apiOrigin } from '../../lib/apiClient'
import type { ApiResponse } from '../../types'

export default function Branding() {
  const { data } = useQuery({
    queryKey: ['public-settings'],
    queryFn: async () =>
      (
        await apiClient.get<ApiResponse<Record<string, string>>>(
          '/public/settings',
        )
      ).data.data,
  })
  useEffect(() => {
    if (!data) return
    const root = document.documentElement
    for (const [key, variable] of [
      ['primary_color', '--admin-primary'],
      ['secondary_color', '--admin-secondary'],
    ]) {
      if (/^#[0-9a-f]{6}$/i.test(data[key] ?? ''))
        root.style.setProperty(variable, data[key])
    }
    if (/^#[0-9a-f]{6}$/i.test(data.primary_color ?? ''))
      root.style.setProperty(
        '--admin-primary-rgb',
        [1, 3, 5]
          .map((i) => parseInt(data.primary_color.slice(i, i + 2), 16))
          .join(', '),
      )
    if (data.favicon?.startsWith('/storage/branding/')) {
      const icon =
        document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
        document.createElement('link')
      icon.rel = 'icon'
      icon.href = apiOrigin + data.favicon
      document.head.appendChild(icon)
    }
  }, [data])
  return null
}
